import React from 'react'
import { TFunction } from 'i18next'
import { ObjectType } from 'types/ApiResponse'

export const getObjectTypeOptions = (isDE: boolean, t: TFunction, isValue: boolean = false) => {
  const objectTypes = [
    {
      key: ObjectType.HOUSE,
      value: (
        <span>
          {t(`objectType.${ObjectType.HOUSE.toLowerCase()}`)}{' '}
          <p>{t(`objectType.${ObjectType.HOUSE.toLowerCase()}.tag`)}</p>
        </span>
      ),
      tooltip: t(`objectType.${ObjectType.HOUSE.toLowerCase()}.tooltip`),
    },
    {
      key: ObjectType.APARTMENT,
      value: (
        <span>
          {t(`objectType.${ObjectType.APARTMENT.toLowerCase()}`)}{' '}
          <p>{t(`objectType.${ObjectType.APARTMENT.toLowerCase()}.tag`)}</p>
        </span>
      ),
      tooltip: t(`objectType.${ObjectType.APARTMENT.toLowerCase()}.tooltip`),
    },
    {
      key: ObjectType.MULTI_FAMILY_HOUSE,
      value: (
        <span>
          {t(`objectType.${ObjectType.MULTI_FAMILY_HOUSE.toLowerCase()}`)}{' '}
          <p>{t(`objectType.${ObjectType.MULTI_FAMILY_HOUSE.toLowerCase()}.tag`)}</p>
        </span>
      ),
      tooltip: t(`objectType.${ObjectType.MULTI_FAMILY_HOUSE.toLowerCase()}.tooltip`),
    },
  ]

  if (isValue) {
    objectTypes.push({
      key: ObjectType.PLOT_OF_LAND,
      value: (
        <span>
          {t(`objectType.${ObjectType.PLOT_OF_LAND.toLowerCase()}`)}{' '}
          <p>{t(`objectType.${ObjectType.PLOT_OF_LAND.toLowerCase()}.tag`)}</p>
        </span>
      ),
      tooltip: t(`objectType.${ObjectType.PLOT_OF_LAND.toLowerCase()}.tooltip`),
    })
  }

  return isDE
    ? objectTypes
    : objectTypes.filter((item) => item.key !== ObjectType.MULTI_FAMILY_HOUSE)
}
